export class BillingAdditionalInfos {
    constructor() {
        this.electronicInvoicingEmail = null;
        this.orderReferenceNumber = null;
    }
}
